
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 183.72 244.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M122 206.23a4.8 4.8 0 01-4.81-4.8v-60a4.81 4.81 0 019.61 0v60a4.8 4.8 0 01-4.8 4.8zM91.86 206.23a4.81 4.81 0 01-4.81-4.8v-90.65a4.81 4.81 0 019.61 0v90.65a4.8 4.8 0 01-4.8 4.8zM61.72 206.23a4.8 4.8 0 01-4.8-4.8v-44.2a4.8 4.8 0 019.6 0v44.2a4.8 4.8 0 01-4.8 4.8z"}}),_c('path',{attrs:{"d":"M111.94 1.93h-96.1A14.39 14.39 0 001.45 16.32v212.31A14.4 14.4 0 0015.84 243h152a14.4 14.4 0 0014.39-14.4V72.26a8.69 8.69 0 00-2.56-6.17l-61.6-61.6a8.73 8.73 0 00-6.13-2.56zm8.34 18.32l43.53 43.52h-42.13a1.4 1.4 0 01-1.4-1.4zm47.6 213.17h-152a4.79 4.79 0 01-4.79-4.79V16.32a4.79 4.79 0 014.79-4.78h94.84v50.83a11 11 0 0011 11h51v155.26a4.78 4.78 0 01-4.84 4.79z"}})])
          )
        }
      }
    